<template>
  <v-alert v-if="status" density="compact" :type="alertType" :color="alertColor" class="mb-4">{{text}}</v-alert>
</template>
<script>
import {eh} from "@/plugins/eventhandler"

const ALERT_COLORS = {
  success: "#4CAF50",
  warning: "#FB8C00",
  error: "#E53935",
  info: "#1E88E5",
}

export default {
  name: "Alert",
  props: {
    page: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    status: null,
    mode: null,
    text: null,
  }),
  computed: {
    alertType() {
      return ALERT_COLORS[this.mode] ? this.mode : "info"
    },
    alertColor() {
      return ALERT_COLORS[this.mode] || ALERT_COLORS.info
    },
  },
  watch: {
    page(value) {
      this.text = value.text;
      this.status = value.status;
      this.mode = value.mode;
    }
  },
  mounted() {
    this.status = this.page.status;
    this.mode = this.page.mode;
    this.text = this.page.text;
    var p = this;
    eh.on("alert", function(update) {
      p.status = update.status;
      p.mode = update.mode;
      p.text = update.text;
    });
  },
  methods: {}
}
</script>
<style scoped>
    .v-alert {
        font-size: 14px;
        padding: 10px;
    }
</style>